import { SelectOption } from '../types'

export const propertyType = [
  'Standard House',
  'Architecturally Designed Home',
  'Townhouse',
  'Units',
  'Apartments',
  'Project Home',
  'Project Units',
]

export const propertyTypeOptions: SelectOption[] = propertyType.map((propertyType) => ({
  value: propertyType,
  label: propertyType,
}))
